export default "/images/acba_bank.png?bd39fc00086713c882402ee731cae5f4";